import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { IndicadorClienteInserirComponent } from "./indicador-cliente-inserir.component"; 
import { FormsModule } from "@angular/forms";
import { IndicadorClienteInserirRoutingModule } from "./indicador-cliente-inserir-routing.module";
import { MessagesModule } from 'primeng/messages';

@NgModule({
    imports: [
        CommonModule,             
        IndicadorClienteInserirRoutingModule,
        FormsModule,
        InputTextModule,
        ButtonModule,
        MessagesModule
    ],
    declarations: [IndicadorClienteInserirComponent]
})
export class IndicadorClienteInserirModule { }
